import React from 'react'
import { useIntl } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { useGetRelativeDate } from '../../hooks/useGetRelativeDate'
import { BodyTextSize } from '../../styles/typeStyles'
import { BodyText } from '../bodyText/BodyText'

export type ConversationTimeProps = {
  time: Date | null
  threadCount?: number
}

const ConversationText = styled(BodyText)<{ hide: boolean }>(({ hide }) => ({
  opacity: hide ? 0 : 1,
}))
export const ConversationTime: React.FC<ConversationTimeProps> = ({ time, threadCount }) => {
  const { colors } = useTheme()
  const intl = useIntl()
  const getRelativeDate = useGetRelativeDate()
  const threadLabel =
    threadCount && threadCount > 1
      ? intl.formatMessage(
          { defaultMessage: '{threadCount} threads', description: 'Conversation count in a client inbox row' },
          { threadCount },
        )
      : null
  const formatted = time ? getRelativeDate(time) : null
  return (
    <ConversationText
      hide={!formatted && !threadLabel}
      text={[threadLabel, formatted].filter(Boolean).join(' · ')}
      size={BodyTextSize.SMALL}
      color={colors.textSecondary}
      numberOfLines={1}
    />
  )
}
